export const MY_ORGANIZATION_API = '/api/organizations/me';

export const PERSON_OF_CONTACT_API = '/api/organizations/me/person-of-contact';
